export enum FacebookStandardEvent {
    SIGNED_UP = 'CompleteRegistration',
};
